import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { faUpload } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, DashboardModuleListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import { generateUrls as generateCampaignUrls } from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'
import useOrderItem from '@hooks/useOrderItem'
import useService from '@hooks/useService'
import useStatus from '@hooks/useStatus'

import type { OrderItemModel } from '@models/types'

interface OrderItemsListItemProps {
  orderItem: OrderItemModel,
}

const OrderItemsListItem = (props: OrderItemsListItemProps) => {
  const {
    orderItem,
    orderItem: {
      artwork_id, id, options_string, quantity, status_id, title,
    },
  } = props

  const useOrderItemPayload = useOrderItem(orderItem)
  const {
    callbacks: {
      manageBrandOrderArtworkModal,
      manageProviderOrderItemModal,
    },
    order: {
      campaign_id,
    },
    service,
  } = useOrderItemPayload

  const { color, status } = useStatus({ id: status_id })

  const { isBrandUser, isProviderUser } = useCurrentUser()

  const handleClick = () => {
    if (isProviderUser) manageProviderOrderItemModal()
    if (isBrandUser && !!artwork_id) manageBrandOrderArtworkModal()
  }

  const { isImageable } = useService(service)

  const showUploadMedia = !!campaign_id && isImageable

  const { campaignMediaProviderUrl } = generateCampaignUrls({ id: campaign_id })

  const campaignMediaProviderUrlWithRedirect = `${campaignMediaProviderUrl}?redirect=${generateRedirectUrl()}`

  return (
    <DashboardModuleListItem
      title={(
        <Box flexDirection="row" alignItems="center">
          <StatusBadge
            boxProps={{ marginRight: 'medium', minWidth: '100px' }}
            color={color}
            // @ts-expect-error TS2339
            text={status.title}
          />
          <Text variant="ellipsis">{`${quantity} x ${title} ${options_string}`}</Text>
        </Box>
      )}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        <Box alignItems="center" justifyContent="end">
          {showUploadMedia && (
            <Button
              // @ts-expect-error TS2322
              as="a"
              buttonStyle="secondaryUtility"
              href={campaignMediaProviderUrlWithRedirect}
              icon={<FontAwesomeIcon icon={faUpload} />}
              marginRight="large"
              size="small"
              width="auto"
            >
              Upload Media
            </Button>
          )}

          <Text color="bodyFontLightColor">{`#${id}`}</Text>
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={isProviderUser || (isBrandUser && !!artwork_id) ? handleClick : null}
          type="edit"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>

    </DashboardModuleListItem>
  )
}

export default OrderItemsListItem
